import { createFileRoute } from '@tanstack/react-router';

import { loadPixMedMessages, loadPixMedScreens, pixMedAdminScreen, pixMedSearch } from '@/modules/pix-med/route';
import { lazyScreen } from '@/shared/screen/lazy-screen';

// Pix Med Admin no caminho do legado (`router.tsx:684-691`): o menu passa a apontar para cá quando o
// manifesto entra em `src/app/screens.ts`. Arquivo leve (JS inicial); a tela vem em chunk próprio.
export const Route = createFileRoute('/_app/contas-digitais/pix-med-admin/')({
  validateSearch: pixMedSearch,
  staticData: { screen: pixMedAdminScreen },
  loader: () => loadPixMedMessages(),
  component: lazyScreen(loadPixMedScreens, 'PixMedAdminRouteScreen'),
});
